import { fetchOwnerAccount } from 'common/api/fetcher/common/queries'
import { useQuery } from 'react-query'

export const useOwnerAccount = () =>
  useQuery(['owner', 'account'], () => fetchOwnerAccount())
